/** Toolbox ▸ SDMS Template Builder — constants shared by the list and the editor. */

/** dbo.AuditData.FormName — registered in CLAUDE.md §14b.2 and aiAuditForms.ts. */
export const FORM_NAME = 'SDMS Template Builder';
/** nav id (navData.ts / nav-registry.json). */
export const PAGE_ID = 'sdms-template-builder';

/** SpreadSheetBuilder_TemplateInfo.Model. */
export const MODELS = [
  { id: 0, label: 'Batch Sample Entry' },
  { id: 1, label: 'Sample Sheet Navigation (sheet per run)' },
  { id: 2, label: 'Calibration Set' },
  { id: 3, label: 'Field Sample Collection' },
  // SampleQCSplit (Windows builder 2026-09-30): saving it renames the detail sheet to SampleResults and adds a
  // QCResults copy (server: XlsxSampleQcSplitWriter); Result Entry puts the samples on one and the QC on the other.
  { id: 4, label: 'SampleQCSplit' },
] as const;
